import * as React from 'react';
import styled from 'styled-components';
import {StyledContainer} from 'containers/Container';
import ScheduleItem, {ScheduleItemStatus} from './components/ScheduleItem';
import Checkbox from 'components/Checkbox';
import {CourseObject} from 'api/course';

export interface options {
  opened: number | boolean;
  weekSep?: boolean;
}

const Container = styled(StyledContainer)`
  padding: 0;
  display: grid;
  gap: 6px;
  height: max-content;
`;

const Options = styled.div`
  display: grid;
  grid-template-columns: repeat(2, max-content);
  gap: 20px;
  margin: 21px 16px;
`;

const OptionItem = styled.label`
  display: grid;
  grid-template-columns: repeat(2, max-content);
  gap: 10px;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
`;

/**
 * This component renders course schedule.
 * @param {CourseObject} props
 * @return {React.ReactElement}
 * @constructor
 */
export default function CourseSchedule(props: CourseObject)
  : React.ReactElement {
  const [options, setOptions] = React.useState<options>({opened: false});

  // todo пофиксить или заменить
  /**
   * the function render course schedule items
   * @return {React.ReactElement}
   * @constructor
   */
  function renderOptions() {
    return (
      <Options>
        <OptionItem>
          <Checkbox
            checked={options.opened === true}
            onChange={() => {
              options.opened !== true
              && setOptions({...options, opened: true});

              options.opened === true
              && setOptions({...options, opened: false});
            }}
          />
          Развернуть все дни
        </OptionItem>
      </Options>
    );
  }

  /**
   * the function render course schedule items
   * @return {React.ReactElement}
   * @constructor
   */
  function renderItems() {
    let chapterNumber = 0;

    function getChapterLabelByTitle(title?: string) {
      if (title) {
        chapterNumber += 1;
        return chapterNumber + ' глава';
      }
      return 'Выходной день'
    }

    if (props?.programs?.content) {
      if ('chapters' in props.programs.content) {
        const items = props.programs.content.chapters;

        return items.map((chapter, ind) =>  {
          const status: ScheduleItemStatus = chapter.title
              ? ScheduleItemStatus.Opened
              : ScheduleItemStatus.isRest;

          return (
            <ScheduleItem
              key={chapter.id}
              opened={
                ind === options.opened
                || options.opened === true
              }
              day={getChapterLabelByTitle(chapter.title)}
              title={chapter.title}
              status={status}
              content={chapter.content}
              closed={!chapter.title}
            />
          )
        });
      }
    }
  }

  return (
    <Container>
      {renderItems()}
    </Container>
  );
}
